import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  Spinner
} from 'reactstrap';

/**
 * Modal para confirmar la desasignación de un plan
 */
const DesasignarPlanModal = ({
  isOpen,
  toggle,
  ordenId,
  ordenNombre,
  planNombre,
  onConfirm,
  loading = false,
  error = null
}) => {
  const [confirmText, setConfirmText] = useState('');

  // Resetear el estado cuando se abre/cierra el modal
  React.useEffect(() => {
    if (isOpen) {
      setConfirmText('');
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (confirmText === 'DESASIGNAR') {
      onConfirm(ordenId);
    }
  };

  const isConfirmValid = confirmText === 'DESASIGNAR';

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" centered>
      <ModalHeader toggle={toggle}>
        <i className="fas fa-exclamation-triangle text-warning me-2"></i>
        Desasignar Plan
      </ModalHeader>
      
      <ModalBody>
        {error && (
          <Alert color="danger" className="mb-3">
            <i className="fas fa-exclamation-circle me-2"></i>
            {error}
          </Alert>
        )}

        <div className="mb-3">
          <p className="mb-2">
            <strong>¿Está seguro que desea desasignar el plan de esta orden?</strong>
          </p>
          
          <div className="bg-light p-3 rounded">
            <p className="mb-1"><strong>Orden:</strong> {ordenNombre}</p>
            <p className="mb-0"><strong>Plan:</strong> {planNombre}</p>
          </div>
        </div>

        <Alert color="warning" className="mb-3">
          <i className="fas fa-info-circle me-2"></i>
          <strong>Importante:</strong> Esta acción solo es posible si la orden no tiene avance 
          (ninguna tarea ha iniciado). Se eliminarán todos los registros relacionados con el plan.
        </Alert>

        <div className="mb-3">
          <label htmlFor="confirmText" className="form-label">
            Para confirmar, escriba <strong>DESASIGNAR</strong> en el campo:
          </label>
          <input
            type="text"
            id="confirmText"
            className="form-control"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
            placeholder="Escriba DESASIGNAR aquí"
            disabled={loading}
          />
        </div>
      </ModalBody>
      
      <ModalFooter>
        <Button
          color="secondary"
          onClick={toggle}
          disabled={loading}
        >
          Cancelar
        </Button>
        
        <Button
          color="danger"
          onClick={handleConfirm}
          disabled={!isConfirmValid || loading}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Desasignando...
            </>
          ) : (
            <>
              <i className="fas fa-trash me-2"></i>
              Desasignar Plan
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DesasignarPlanModal;
